module.exports = __webpack_public_path__ + "static/media/logoyomi.c3dee6d5.png";